import { render } from "./contact.vue?vue&type=template&id=2a13ef2e&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"

import "./contact.vue?vue&type=style&index=0&id=2a13ef2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a13ef2e"]])

export default __exports__